import { useCallback, useMemo } from 'react';

import { useT } from '../../../i18n';
import { useAuthStore } from '../../../stores/auth';
import { useTatCaNguoiDung } from '../../nguoi-dung/hooks/useNguoiDung';

/** `created_by` của dữ liệu do migration nạp (ADR-0066 mục 6). */
const NGUOI_HE_THONG = '00000000-0000-0000-0000-000000000000';

/**
 * Đổi `created_by` (sub Keycloak) của module `ocr` thành tên hiển thị.
 *
 * Module chỉ lưu UUID, không lưu tên (MUSE.md: hồ sơ người dùng ở lõi). Tên tra từ danh sách người
 * của tổ chức (`GET /api/v1/users`); người không có quyền xem danh sách (`USER_CONFIG`) nhận `403`
 * và lùi về mã rút gọn. Chính mình luôn hiện `Bạn`.
 */
export function useTenNguoi(): (id: string | null | undefined) => string | null {
  const { t } = useT();
  const toi = useAuthStore((s) => s.user?.id);
  const ds = useTatCaNguoiDung();
  const theoId = useMemo(() => new Map((ds.data ?? []).map((u) => [u.user_id, u.display_name])), [ds.data]);

  return useCallback(
    (id) => {
      if (!id) return null;
      if (id === NGUOI_HE_THONG) return t('ocr.heThong');
      if (id === toi) return t('ocr.ban');
      return theoId.get(id) ?? t('ocr.nguoiDungMa', { ma: id.slice(0, 8) });
    },
    [t, toi, theoId],
  );
}
